var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"board__list-empty pa-5 grey lighten-5 text-center"},[_c('span',{staticClass:"grey--text"},[_vm._v(" "+_vm._s(_vm.$t('emptyState.noData'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }